module.exports = __webpack_public_path__ + "media/images/h3-050ce2070e81c234f508aa7cf8bc6941.svg";